module.exports = __webpack_public_path__ + "static/img/12areaB_15.4fa29d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_15.png
// module id = 1116
// module chunks = 1